/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-param-reassign */
/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { ContactService } from "@services";
import utils from "@utils";
import { Modal } from "../../../../../components";
import "./styles.scss";

const EditRecipient = ({
	show,
	onCancel,
	onShowCreateNewClient,
	contactData,
	updateRecipients,
	recipientState,
	clientId,
	onShowPaymentConfirmationModal,
	isEstimate,
	billToEmail,
	billToEmailList,
}) => {
	const { lang } = global;
	const [clientEmailList, setClientEmailList] = useState({ isLoading: true, data: [] });
	const [ccList, setCCList] = useState([]);
	const [bccList, setBCCList] = useState("");
	const [bccError, setBccError] = useState(false);
	const [emailToMyself, setEmailToMyself] = useState(false);
	const [selectedClientBillToEmail, setSelectedClientBillToEmail] = useState(null);
	let newEmailList = "";

	const handleEmailToMyselfChange = e => {
		setEmailToMyself(e.target.checked);
	};

	const handleCCListChange = e => {
		setCCList(e);
	};

	const validateBcc = bcc => {
		if (typeof bcc !== "string") return true;

		const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
		const splitedEmail = bcc.replace(/[\n\r\t]/gm, "").split(",");
		const uniqueEmails = new Set();

		splitedEmail.forEach(email => {
			const trimmedEmail = email.trim();

			if (!uniqueEmails.has(trimmedEmail)) {
				uniqueEmails.add(trimmedEmail);
			}
		});

		setBCCList([...uniqueEmails].join(","));
		newEmailList = [...uniqueEmails].join(",");

		return bcc !== ""
			? [...uniqueEmails].reduce((acc, email) => acc && emailRegex.test(email), true)
			: true;
	};

	const handleBCCListChange = e => {
		setBCCList(e.target.value);
	};

	const closeModal = () => {
		setCCList([]);
		setBCCList("");
		setBccError(false);

		onCancel();
	};

	const mapClientListItems = data => {
		const clientEmailListItems = data.ItemList.map(({ Id, ContactName, EmailAddress }) => ({
			value: Id,
			label: EmailAddress,
			EmailAddress,
			ContactName,
			BillingContactId: data.BillingContactId,
		}));
		setClientEmailList({ isLoading: false, data: clientEmailListItems });
	};

	useEffect(() => {
		if (recipientState) {
			const cc = clientEmailList.data.filter(
				elm =>
					recipientState.InvoiceCCRecipients &&
					recipientState.InvoiceCCRecipients.includes(elm.EmailAddress),
			);
			const bcc = recipientState.InvoiceBCCRecipients
				? recipientState.InvoiceBCCRecipients.join(", ")
				: "";

			if (cc) setCCList(cc);
			if (bcc) {
				setBCCList(bcc);
			} else {
				setBCCList("");
			}

			setEmailToMyself(recipientState.SendEmailToMyself ?? false);
		}
	}, [recipientState]);

	useEffect(() => {
		if (contactData && show) {
			mapClientListItems(contactData);
		}
	}, [contactData, show]);

	useEffect(() => {
		if (!contactData && show) {
			ContactService.getAll({ clientId })
				.then(({ data }) => {
					mapClientListItems(data);
				})
				.catch(() => {
					utils.notify({
						type: "error",
						message: lang.t("Error loading client contacts"),
						timeOut: 1500,
					});
				});
		}
	}, [contactData, show]);

	useEffect(() => {
		if (billToEmailList.length > 1 && billToEmail) {
			const defaultOpt = billToEmailList.find(o => o.value === billToEmail);
			setSelectedClientBillToEmail(defaultOpt || null);
		}
	}, [billToEmailList, billToEmail]);

	const onApply = () => {
		const isBccValid = validateBcc(bccList);
		const isBillingContactValid = !!billToEmail;
		setBccError(!isBccValid);

		if (isBccValid && isBillingContactValid) {
			updateRecipients({
				InvoiceCCRecipients: ccList.map(elm => elm.EmailAddress),
				BillingContactEmail: selectedClientBillToEmail ? selectedClientBillToEmail.value : billToEmail,
				InvoiceBCCRecipients:
					bccList !== "" ? newEmailList.split(",").map(email => email.trim()) : [],
				SendEmailToMyself: emailToMyself,
			});
			if (onShowPaymentConfirmationModal) {
				onShowPaymentConfirmationModal();
			}
			setCCList([]);
			setBCCList("");
			setEmailToMyself(false);
			onCancel();
		}
	};

	return (
		<Modal
			show={show}
			onHide={onCancel}
			id="send-recipients-for-all-modal"
		>
			<Modal.Header closeButton>
				<Modal.Title>
					{lang.t("Edit Recipients")}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body id="send-recipients-for-all-modal">
				<div className="row form-group">
					<div className="col-xs-12">
						<small>
							{isEstimate
								? lang.t("Estimate will be sent to all the recipients selected below")
								: lang.t("Invoice will be sent to all the recipients selected below")
							}
						</small>
					</div>
				</div>

				<If condition={billToEmailList && billToEmailList.length > 1}>
					<div className="row form-group">
						<div className="col-xs-6">
							<label>{lang.t("To")}</label>
							<span className="required-mark" />
						</div>
						<Select
							id="bill-to-email"
							className="col-xs-12"
							name="billToEmail"
	   						options={billToEmailList}
							value={selectedClientBillToEmail}
							onChange={opt => setSelectedClientBillToEmail(opt)}
						/>
					</div>
				</If>
				<If condition={!billToEmailList || billToEmailList.length <= 1}>
					<div className="row form-group">
						<div className="col-xs-12">
							<label>{lang.t("To")}</label>
							<span className="required-mark" />
						</div>
						<div className="col-xs-12">{billToEmail}</div>
					</div>
				</If>
				<div className="row form-group">
					<div className="col-xs-6">
						<label>{lang.t("CC")}:</label>
						<span className="required-mark" />
					</div>
					<div className="col-xs-6 text-right">
						<button
							type="button"
							id="open-add-client-modal"
							className="btn btn-link btn-blue-small"
							onClick={onShowCreateNewClient}
						>
							{`+ ${lang.t("Add new client contact")}`}
						</button>
					</div>
					<Select
						id="client-id"
						className="col-xs-12"
						name="clientId"
						options={clientEmailList.data}
						isLoading={clientEmailList.isLoading}
						value={ccList}
						onChange={handleCCListChange}
						isMulti
					/>
				</div>

				<div className="row form-group">
					<div className="col-xs-12">
						<small>
							{lang.t(
								"Need to send to additional people? Add emails below, separated by a comma",
							)}
						</small>
					</div>
					<div className="col-xs-12">
						<textarea
							className={`form-control ${bccError ? "error" : ""}`}
							placeholder={lang.t("BCC")}
							value={bccList}
							onChange={handleBCCListChange}
						/>
						{bccError && (
							<small className="text-danger">
								{lang.t(
									"The email format you’ve added is incorrect, please add an email with a valid format",
								)}
							</small>
						)}
					</div>
				</div>

				<div>
					<input
						type="checkbox"
						name="send-email-to-myself"
						checked={emailToMyself}
						onChange={handleEmailToMyselfChange}
					/>
					<small className="send-email-to-myself-label">
						{lang.t("Send an email to myself")}
					</small>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<button
					type="button"
					className="btn btn-default"
					onClick={closeModal}
				>
					{lang.t("Cancel")}
				</button>

				<button
					type="button"
					className="btn btn-primary"
					onClick={onApply}
				>
					{lang.t(onShowPaymentConfirmationModal ? "Send" : "Apply")}
				</button>
			</Modal.Footer>
		</Modal>
	);
};

EditRecipient.propTypes = {
	show: PropTypes.bool,
	onCancel: PropTypes.func,
	onShowCreateNewClient: PropTypes.func,
	contactData: PropTypes.object,
	updateRecipients: PropTypes.func,
	recipientState: PropTypes.object,
	onShowPaymentConfirmationModal: PropTypes.func,
	billToEmail: PropTypes.string,
	billToEmailList: PropTypes.object
};

EditRecipient.defaultProps = {
	show: false,
	onCancel: () => {},
	onShowPaymentConfirmationModal: null,
	billToEmail: null,
	billToEmailList: [],
};

export default EditRecipient;
